var _path, _path2, _path3, _path4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPendingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.07727 9.1894C3.07727 9.77448 3.55134 10.2487 4.13627 10.2487C4.72131 10.2487 5.19545 9.77448 5.19545 9.1894C5.19545 8.60456 4.72131 8.13037 4.13627 8.13037C3.55134 8.13037 3.07727 8.60456 3.07727 9.1894",
    fill: "#3E5573"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.10583 9.1894C6.10583 9.77448 6.57991 10.2487 7.16484 10.2487C7.74973 10.2487 8.224 9.77448 8.224 9.1894C8.224 8.60456 7.74973 8.13037 7.16484 8.13037C6.57991 8.13037 6.10583 8.60456 6.10583 9.1894",
    fill: "#3E5573"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1933 10.2487C10.7782 10.2487 11.2525 9.77448 11.2525 9.1894C11.2525 8.60456 10.7782 8.13037 10.1933 8.13037C9.60838 8.13037 9.13428 8.60456 9.13428 9.1894C9.13428 9.77448 9.60838 10.2487 10.1933 10.2487",
    fill: "#3E5573"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_5875",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 17
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H14.3298V16.3544H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_5875)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5684 3.5371C11.2531 3.29104 10.7974 3.34742 10.5512 3.66261C10.3051 3.97826 10.3612 4.43382 10.6769 4.67988C12.0772 5.7724 12.8803 7.41604 12.8803 9.18942C12.8803 12.341 10.3164 14.905 7.1649 14.905C4.01342 14.905 1.44947 12.341 1.44947 9.18942C1.44947 6.15742 3.82317 3.67039 6.80972 3.48614L6.03462 4.26136C5.75152 4.54423 5.75152 5.00308 6.03451 5.28619C6.17606 5.42773 6.36149 5.4985 6.54703 5.4985C6.73246 5.4985 6.91802 5.42773 7.05945 5.28619L9.08396 3.26179C9.21996 3.12589 9.29629 2.94164 9.29629 2.74937C9.29629 2.5571 9.21996 2.37286 9.08408 2.23696L7.05956 0.212328C6.77647 -0.0707761 6.31749 -0.0707761 6.03462 0.212328C5.75152 0.495195 5.75152 0.954048 6.03451 1.23715L6.83043 2.03314C3.03442 2.20841 0 5.35083 0 9.18942C0 13.1403 3.21413 16.3544 7.1649 16.3544C11.1157 16.3544 14.3298 13.1403 14.3298 9.18942C14.3298 6.96637 13.3233 4.90612 11.5684 3.5371",
    fill: "#3E5573"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/Pending_icon.a7e41b32.svg";
export { ForwardRef as ReactComponent };